import { useEffect, useState } from 'react';

// Estado + accesibilidad del drawer de navegación móvil. Reutilizable entre el
// admin y el portal colaborador (mismo patrón en ambos SPAs). Mientras el drawer
// está abierto bloquea el scroll del body y permite cerrarlo con Escape.
export function useSidebarDrawer() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setOpen(false);
    };
    document.addEventListener('keydown', onKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [open]);

  return { open, setOpen, close: () => setOpen(false) };
}
